import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountConfig } from '@shared/products-feature-configs';

import { overdraftDetail } from '../overdraft-detailed-v2-config/HU';
import { settingsDetails } from '../settings-details-config/HU';
import { statements } from '../statements-config/HU';

export const currentAccount: DeepPartial<CurrentAccountConfig> = {
    overdraftDetail,
    roundingSavings: {
        enabled: false,
    },
    sepaMandatesRead: {
        enabled: false,
    },
    accountAddress: {
        enabled: false,
    },
    statements,
    settingsDetails,
    layout: {
        productInfo: {
            showDisposableAndBalanceAmounts: true,
        },
    },
};
